import { ScrapEyesEventWithReviewData } from "components/manualReview/contexts/ManualReviewEventContext";
import { sorted } from "helpers";

export interface FlaggedEventRow {
  event: ScrapEyesEventWithReviewData;
  isFlagged: boolean;
}

export const flaggedEventRows = ({
  events,
  flaggedEventIds,
  visibility = "flagged",
}: {
  events: readonly ScrapEyesEventWithReviewData[];
  flaggedEventIds: readonly string[];
  visibility?: "flagged" | "all";
}): FlaggedEventRow[] => {
  const flagged = new Set(flaggedEventIds);
  const rows =
    visibility === "all" || flagged.size === 0
      ? events
      : events.filter((event) => flagged.has(event.id));
  return sorted([...rows], (event) => event.start.valueOf()).map((event) => ({
    event,
    isFlagged: flagged.has(event.id),
  }));
};
